import { generateId } from '@freelancer/datastore/testing/helpers';
import type { RecommendedUsername } from './recommended-usernames.model';

export interface GenerateRecommendedUserNamesOptions {
  readonly id?: string;
  readonly email?: string;
  readonly username?: string;
  readonly baseName?: string;
  readonly captchaChallenge?: string;
  readonly captchaResponse?: string;
}

export function generateRecommendedUserNamesObject({
  id = `${generateId()}`,
  email = 'test@email.com',
  username = 'test',
  baseName = 'Sample',
  captchaChallenge,
  captchaResponse,
}: GenerateRecommendedUserNamesOptions = {}): RecommendedUsername {
  return {
    id,
    email,
    username,
    baseName,
    captchaChallenge,
    captchaResponse,
  };
}
